import React from 'react'
import PropTypes from 'prop-types'
import { useQueryParam, ArrayQueryOptions } from 'src/hooks'
import { TableContext } from 'src/contexts'
import { MultiSelectInput } from 'src/components/inputs'

const FilterTableInput = ({ name, filter, ...props }) => {
  // get filter value and updater
  const [value, onChange] = useQueryParam(name, ArrayQueryOptions)

  // get filter registering function from table context
  const { useFilter } = TableContext.use()

  // register filter
  useFilter(
    {
      name,
      filter: item => !filter || !value || !value.length || filter(item, value),
      reset: () => onChange([]),
      count: value.length,
    },
    [value]
  )

  return <MultiSelectInput value={value} onChange={onChange} {...props} />
}

FilterTableInput.propTypes = {
  ...MultiSelectInput.propTypes,
  name: PropTypes.string,
  filter: PropTypes.func,
}

export default FilterTableInput
